export const imgPath = "http://120.201.230.21:10001/files"
export const cityId = 4
export const permissionsId = 4
export const metatitle = "铁岭县纪检监察网"
export const keywords = "铁岭县纪委,铁岭县监察委员会"
export const description = "中共铁岭县纪律检查委员会 铁岭县监察委员会"
export const SiteName = "铁岭县纪委监委网站"
export const SiteDomain = "tls.tlsjw.gov.cn:10001/tlx"


// WEBPACK FOOTER //
// ./src/api/api.js